import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Achievements from './Achievements';
import HeroSection from './HeroSection';
import Card from './Card';
import Owl from './Owl';
import Services from './Services';
import Technologies from './Technologies';
import { Helmet } from 'react-helmet';
const IOSIndex = (props) => {
    const { slug } = useParams()
    // =========================== scroll To Top default =========================
    useEffect(() => {
        props.demo('top')
    }, [slug])
    // =========================== scroll To Top default =========================
    return (
        <>
            <Helmet>
                <title>IOS App Development Company - Infograins</title>
                <meta name="description" content="Infograins is an award winning IOS app development company that provides top-notch end to end customized IOS applications." />
            </Helmet>
            <HeroSection />
            <Achievements />
            <Services />
            <Technologies />
            <Owl />
            <Card />
        </>
    )
}

export default IOSIndex